
    import Vue from 'vue';

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
export const asyncRoutes = [
  // 首页
  {
    name: 'HOME-INDEX',
    path: '/',
    component: () => import('@/xreports/views/home/index'),
    meta: {
      title: $t('f6e62f'),
    },
    children: [
      {
        name: 'QUALITY-INSPECTION-INDEX',
        path: '/quality-inspection',
        component: () => import('@/xreports/views/home/QualityInspection'),
        meta: {
          layoutClass: 'quality-inspection-index-layout-wrapper',
          title: $t('ef03ef'),
        },
      },
      {
        name: 'DASHBOARD-INDEX',
        path: '/dashboard',
        component: () => import('@/xreports/views/dashboard/dashboard'),
        meta: {
          layoutClass: 'dashboard-board-index-layout-wrapper',
          title: $t('977207'),
        },
      },
    ],
  },
  // 看板
  {
    name: 'CUSTOMIZED-DASHBOARD-EMPTY',
    path: '/configuration-center/board/empty',
    meta: {
      title: $t('ec276b'),
    },
    component: () => import('@/xreports/views/customized-dashboard/empty'),
  },
  {
    name: 'CUSTOMIZED-DASHBOARD-INDEX',
    path: '/configuration-center/board/:id',
    meta: {
      title: $t('eac45c'),
    },
    component: () => import('@/xreports/views/customized-dashboard/index'),
  },
  // 分析看板
  {
    name: 'ANALYSIS-DASHBOARD',
    path: '/analysis-dashboard',
    redirect: '/analysis-dashboard/warning-analysis',
    meta: {
      title: $t('8f2557'),
    },
    component: () => import('@/xreports/views/analysis-dashboard/index.vue'),
    children: [
      {
        name: 'ANALYSIS-DASHBOARD-INDEX',
        path: '/analysis-dashboard/dashboard/:id',
        meta: {
          title: $t('8f2557'),
        },
        component: () => import('@/xreports/views/customized-dashboard/index'),
      },
      {
        name: 'ANALYSIS-DASHBOARD-WARNING-ANALYSIS',
        path: '/analysis-dashboard/warning-analysis',
        meta: {
          title: $t('393235'),
        },
        component: () => import('@/modules/action-record/warning-analysis/WarningAnalysis.vue'),
      },
      {
        path: '/service-quality/department-quality',
        name: 'DEPARTMENT-QUALITY',
        meta: {
          title: $t('b747e8'),
        },
        component: () => import('@/hotelcem/views/service-quality/department-quality/index.vue'),
      },
    ],
  },
  // 详情
  {
    name: 'RECORD-DETAILS',
    path: '/record-details',
    redirect: '/record-details/comment',
    meta: {
      title: $t('e6a250'),
    },
    component: () => import('@/xreports/views/record-detail/index.vue'),
    children: [
      {
        name: 'COMMENT-RECORD-DETAILS',
        path: '/record-details/comment',
        meta: {
          title: $t('56b8b5'),
        },
        component: () => import('@/xreports/views/record-detail/CommentDetailPage'),
      },
      {
        name: 'WARNING-RECORD-DETAILS',
        path: '/record-details/warning',
        meta: {
          title: $t('d08abf'),
          layoutClass: 'action-record-warning-rules',
        },
        component: () => import('@/modules/action-record/warning-record/index'),
      },
      {
        name: 'VOICE-RECORD-DETAILS',
        path: '/record-details/voice',
        meta: {
          title: $t('9468cf'),
        },
        component: () => import('@/xreports/views/record-detail/voice-list'),
      },
    ],
  },
  // 数据中心
  {
    name: 'DATA-CENTER-INDEX',
    path: '/data-center',
    redirect: '/data-center/survey-data',
    meta: {
      title: $t('79f45f'),
    },
    component: () => import('@/xreports/views/data-center/index'),
    children: [
      {
        name: 'DATA-CENTER-CSI-DATA',
        path: 'csi-data',
        meta: {
          layoutClass: 'data-center-index-layout-wrapper',
          title: $t('b35398'),
        },
        component: () => import('@/xreports/views/data-center/csi-data/index'),
      },
      {
        // 问卷数据
        name: 'DATA-CENTER-SURVEY-DATA',
        path: 'survey-data',
        meta: {
          layoutClass: 'data-center-index-layout-wrapper',
          title: $t('5f382f'),
        },
        component: () => import('@/xreports/views/data-center/survey-data/index'),
      },
      {
        // 文件数据
        name: 'DATA-CENTER-FILE-DATA',
        path: 'file-data',
        meta: {
          layoutClass: 'data-center-index-layout-wrapper',
          title: $t('2e97aa'),
        },
        component: () => import('@/xreports/views/data-center/file-data/index'),
      },
      {
        // 合表数据
        name: 'DATA-CENTER-MERGED-CELL-DATA',
        path: 'merged-cell-data',
        meta: {
          layoutClass: 'data-center-index-layout-wrapper',
          title: $t('1e2fff'),
        },
        component: () => import('@/xreports/views/data-center/merged-data/index'),
      },
      {
        // 爬虫数据
        name: 'DATA-CENTER-SOCIAL-DATA',
        path: 'social-data',
        meta: {
          layoutClass: 'data-center-index-layout-wrapper',
          title: $t('9080c7'),
        },
        component: () => import('@/xreports/views/data-center/social-data/index'),
      },
      {
        // 语音数据
        name: 'DATA-CENTER-VOICE-DATA',
        path: 'voice-data',
        meta: {
          layoutClass: 'data-center-index-layout-wrapper',
          title: $t('8bd364'),
        },
        component: () => import('@/xreports/views/data-center/voice-data/index'),
      },
      {
        // IM数据
        name: 'DATA-CENTER-IM-DATA',
        path: 'im-data',
        meta: {
          layoutClass: 'data-center-index-layout-wrapper',
          title: $t('081a57'),
        },
        component: () => import('@/xreports/views/data-center/im-data/index'),
      },
      {
        // 对接数据
        name: 'DATA-CENTER-INTEGRATED-DATA',
        path: 'integrated-data',
        meta: {
          layoutClass: 'data-center-index-layout-wrapper',
          title: $t('64b151'),
        },
        component: () => import('@/xreports/views/data-center/integrated-data/index'),
      },
      {
        // 数据详情
        name: 'DATA-CENTER-TABLE-DATA-DETAIL',
        path: 'table-data/:id',
        meta: {
          layoutClass: 'data-center-index-layout-wrapper',
          title: $t('1d7cb1'),
        },
        component: () => import('@/xreports/views/data-center/components/detail'),
      },
      // 报表中心
      {
        name: 'DATA-CENTER-REPORT-CENTER',
        path: 'report-center',
        meta: {
          title: $t('d4e713'),
          hideTitle: true,
        },
        component: () => import('@/xreports/views/data-center/report-center/index'),
      },
    ],
  },
  // 文本分析
  {
    name: 'TEXT-ANALYSIS-INDEX',
    path: '/text-analysis',
    redirect: '/text-analysis/evaluation-management',
    component: () => import('@/xreports/views/text-analysis/index'),
    meta: {
      title: $t('cd613e'),
    },
    children: [
      {
        name: 'TEXT-ANALYSIS-EVALUATION-MANAGEMENT',
        path: 'evaluation-management',
        component: () => import('@/xreports/views/text-analysis/evaluation-management/index'),
        meta: {
          title: $t('3955c3'),
        },
      },
    ],
  },
  // 行动记录
  {
    name: 'ACTION-RECORD-INDEX',
    path: '/action-record',
    redirect: '/action-record/warning-rules',
    meta: {
      title: $t('2c7ee8'),
    },
    component: () => import('@/modules/action-record/index'),
    children: [
      {
        // 预警分析
        name: 'ACTION-RECORD-WARNING-ANALYSIS',
        path: 'warning-analysis',
        meta: {
          title: $t('29d71e'),
        },
        component: () => import('@/modules/action-record/warning-analysis/WarningAnalysis'),
      },
      {
        name: 'ACTION-RECORD-TICKETS-ANALYSIS',
        path: 'tickets-analysis',
        meta: {
          title: $t('26a082'),
        },
        component: () => import('@/modules/action-record/tickets-analysis/TicketsAnalysis'),
      },
      {
        // 预警规则
        name: 'ACTION-RECORD-WARNING-RULES',
        path: 'warning-rules',
        meta: {
          layoutClass: 'action-record-warning-rules',
          title: $t('22c87c'),
        },
        component: () => import('@/modules/action-record/warning-rules/index'),
      },
      {
        // 预警记录
        name: 'ACTION-RECORD-WARNING-RECORD',
        path: 'warning-record',
        meta: {
          layoutClass: 'action-record-warning-rules',
          title: $t('d08abf'),
        },
        component: () => import('@/modules/action-record/warning-record/index'),
      },
      {
        // 预警详情和新建预警
        name: 'ACTION-RECORD-WARNING-RULES-DETAIL',
        path: 'rules-detail',
        meta: {
          layoutClass: 'action-record-warning-rules',
          title: $t('f58e69'),
        },
        component: () => import('@/modules/action-record/rules-detail/index'),
      },
      {
        // 预警记录详情页
        name: 'ACTION-RECORD-WARNING-RECORD-DETAIL',
        path: 'record-detail',
        meta: {
          layoutClass: 'action-record-warning-rules',
          title: $t('574921'),
        },
        component: () => import('@/modules/action-record/record-detail/index'),
      },
    ],
  },

  // 客户管理
  {
    name: 'CUSTOMER-MANAGE',
    path: '/customer-manage',
    redirect: '/customer-manage/customer-center',
    meta: {
      title: 'CDP',
    },
    component: () => import('@/xreports/views/customer-manage/index.vue'),
    children: [
      {
        name: 'CUSTOMER-CENTER',
        path: 'customer-center',
        meta: {
          title: $t('15e652'),
        },
        component: () => import('@/xreports/views/customer-manage/customer-center.vue'),
      },
      {
        name: 'TAGS-MANAGE',
        path: 'tags-manage',
        meta: {
          title: $t('157108'),
        },
        component: () => import('@/xreports/views/customer-manage/tags-manage.vue'),
      },
    ],
  },

  // 配置中心
  {
    name: 'HOTEL-ACTION-MANAGE',
    path: '/hotel-action-manage',
    redirect: '/hotel-action-manage/operation-rank',
    meta: {
      title: $t('5e1466'),
    },
    component: () => import('@/xreports/views/hotel-action-manage/index.vue'),
    children: [
      {
        name: 'HOTEL-ACTION-RANK-LOG',
        path: '/hotel-action-manage/operation-rank',
        component: () => import('@/xreports/views/hotel-action-manage/OperationRank.vue'),
        meta: {
          title: $t('594fa3'),
        },
      },
      {
        name: 'HOTEL-LOGIN-RANK-LOG',
        path: '/hotel-action-manage/login-rank',
        component: () => import('@/xreports/views/hotel-action-manage/LoginRank.vue'),
        meta: {
          title: $t('d67be0'),
        },
      },
    ],
  },
  // 配置中心
  {
    name: 'CONFIGURATION-CENTER-INDEX',
    path: '/configuration-center',
    redirect: '/configuration-center/data',
    meta: {
      title: $t('2bc8f2'),
    },
    component: () => import('@/xreports/views/configuration-center/index'),
    children: [
      {
        name: 'CONFIGURATION-CENTER-DATA',
        path: 'data',
        redirect: '/configuration-center/data/data-source-list',
        component: () => import('@/xreports/views/configuration-center/data/index'),
        meta: {
          title: $t('cc43ce'),
        },
        children: [
          {
            name: 'CONFIGURATION-CENTER-DATA-LIST',
            path: 'data-source-list',
            component: () => import('@/xreports/views/configuration-center/data/data-source-list'),
            meta: {},
          },
          {
            name: 'CONFIGURATION-CENTER-DATA-ADD',
            path: 'data-source-add',
            component: () => import('@/xreports/views/configuration-center/data/data-source-add'),
            meta: {
              title: $t('1acd93'),
            },
          },
          {
            name: 'CONFIGURATION-CENTER-DATA-DETAIL',
            path: 'data-source-detail',
            component: () => import('@/xreports/views/configuration-center/data/data-source-detail'),
            meta: {
              title: $t('1acd93'),
            },
          },
          {
            name: 'CONFIGURATION-CENTER-DATA-EDITOR',
            path: 'data-source-editor',
            component: () => import('@/xreports/views/configuration-center/data/data-source-editor'),
            meta: {
              title: $t('b6fd4b'),
            },
          },
          {
            name: 'CONFIGURATION-CENTER-DATA-TABLE',
            path: 'data-source-table',
            component: () => import('@/xreports/views/configuration-center/data/data-source-table'),
            meta: {
              title: $t('2be9da'),
            },
          },
          {
            name: 'CONFIGURATION-CENTER-DATA-TABLE-RULE',
            path: 'data-source-table-rule',
            component: () => import('@/xreports/views/configuration-center/data/data-source-table-rule'),
            meta: {
              title: $t('2be9da'),
            },
          },
        ],
      },
      {
        name: 'CONFIGURATION-CENTER-BOARD',
        path: 'board',
        component: () => import('@/xreports/views/configuration-center/board/index'),
        meta: {
          layoutClass: 'page-board-index-layout-wrapper',
          title: $t('977207'),
        },
      },
      {
        name: 'CONFIGURATION-CENTER-BOARD-EDIT',
        path: 'board/:id/edit',
        component: () => import('@/xreports/views/configuration-center/board/edit'),
        meta: {
          layoutClass: 'page-board-index-layout-wrapper',
          title: $t('509574'),
        },
      },
      {
        name: 'CONFIGURATION-CENTER-DICTIONARY',
        path: 'custom-dictionary',
        component: () => import('@/xreports/views/configuration-center/custom-dictionary/index'),
        meta: {
          title: $t('04206e'),
        },
      },
      {
        name: 'CONFIGURATION-CENTER-ROBOT-NOTIFICATION',
        path: 'robot-notification',
        component: () => import('@/modules/robot-notification/index'),
        meta: {
          title: $t('af2d33'),
        },
      },
      // 成员管理
      {
        name: 'CONFIGURATION-CENTER-MEMBERS-MANAGEMENT',
        path: 'members-management',
        component: () => import('@/hotelcem/views/configuration-center/members-entry'),
        meta: {
          layoutClass: 'page-employee-basic-wrapper',
          title: $t('c2719a'),
          appName: 'xreports',
        },
      },
      // 组织成员管理
      {
        name: 'CONFIGURATION-CENTER-ORG-MEMBERS-MANAGEMENT',
        path: '/configuration-center/org-members-management',
        meta: {
          title: $t('5b7adb'),
        },
        component: () => import('@/hotelcem/views/configuration-center/org-members-management/index'),
      },
      // 考核指标
      {
        name: 'CONFIGURATION-CENTER-ASSESSMENT-INDICATORS',
        path: 'assessment-indicators',
        component: () => import('@/hotelcem/views/configuration-center/assessment-indicators/index'),
        meta: {
          title: $t('5d4dbe'),
        },
      },
      {
        name: 'CONFIGURATION-CENTER-COMPLAINTS-LEVEL',
        path: 'complaints-level',
        component: () => import('@/hotelcem/views/configuration-center/customer-complaints-levels/index'),
        meta: {
          layoutClass: 'page-customer-complaints-levels-basic-wrapper',
          title: $t('e27ca7'),
          hideInH5: true,
        },
      },
      // 通知中心
      {
        name: 'CONFIGURATION-CENTER-NOTIFICATION-CENTER',
        path: 'notification-center',
        component: () => import('@/xreports/views/configuration-center/notification-center/index'),
        meta: {
          title: $t('309239'),
          hideInH5: true,
        },
      },
      // 通知中心-添加任务
      {
        name: 'CONFIGURATION-CENTER-NOTIFICATION-ADD-TASK',
        path: 'add-task',
        meta: {
          title: $t('5851bc'),
          hideInH5: true,
        },
        component: () => import('@/xreports/views/configuration-center/notification-center/add-task'),
      },
      {
        // 预警规则
        name: 'CONFIGURATION-CENTER-WARNING-RULES',
        path: '/action-record/warning-rules',
        meta: {
          layoutClass: 'page-configuration-center-warning-rules',
          title: $t('22c87c'),
        },
        component: () => import('@/modules/action-record/warning-rules/index'),
      },
      {
        // 预警详情和新建预警
        name: 'CONFIGURATION-CENTER-WARNING-RULES-DETAIL',
        path: '/action-record/rules-detail',
        meta: {
          layoutClass: 'page-configuration-center-warning-rules-detail',
          title: $t('f58e69'),
        },
        component: () => import('@/modules/action-record/rules-detail/index'),
      },
      // 学习园地列表
      {
        name: 'CONFIGURATION-CENTER-LEARNING-CENTER-LIST',
        path: '/configuration-center/learning-center/index',
        component: () => import('@/hotelcem/views/configuration-center/learning-center/index'),
        meta: {
          title: $t('90d5a1'),
        },
      },

      // 学习园地详情
      {
        name: 'CONFIGURATION-CENTER-LEARNING-CENTER-DETAIL',
        path: '/configuration-center/learning-center/detail',
        component: () => import('@/hotelcem/views/configuration-center/learning-center/detail'),
        meta: {
          title: $t('c75885'),
        },
      },
    ],
  },
]

export const constantRoutes = [
  {
    path: '/system/login',
    redirect: '/',
  },

  {
    name: 'SYSTEM-LOGOUT',
    path: '/system/logout',
    component: () => import('@/xreports/views/system/logout'),
    meta: {
      layout: 'blank',
    },
  },
  {
    name: 'USER-INFO',
    path: '/user/info',
    component: () => import('@/modules/user/info'),
  },
  {
    name: 'ENTERPRISE-CONFIGURATION-INDEX',
    path: '/enterprise-configuration',
    redirect: '/enterprise-configuration/management',
    meta: {
      title: $t('cc42c6'),
    },
    component: () => import('@/modules/enterprise-configuration/index'),
    children: [
      {
        name: 'ENTERPRISE-CONFIGURATION-MANAGEMENT',
        path: 'management',
        meta: {
          title: $t('73195b'),
          layoutClass: 'page-enterprise-configuration-management-basic-wrapper',
        },
        component: () => import('@/modules/enterprise-configuration/management'),
      },
    ],
  },
  {
    name: 'COMMENT-LIST',
    path: '/comment/index',
    component: () => import('@/xreports/views/comment-list/index'),
  },
  // 使用条款
  {
    path: '/terms-of-use',
    name: 'TERMS-OF-USE',
    meta: {
      title: $t('559f69'),
    },
    component: () => import('@/components/terms-of-use/index'),
  },
]
